import Raven from 'raven-js';
export const getErrorMessage = err => {
  const errorJSONMaybe = err;
  const jsonMessage = errorJSONMaybe.responseJSON && errorJSONMaybe.responseJSON.message;

  // Check for error message and correlation ID
  if (jsonMessage) {
    const correlationId = errorJSONMaybe.responseJSON && errorJSONMaybe.responseJSON.correlationId;
    return correlationId ? `${jsonMessage}.  Correlation ID: ${correlationId}` : jsonMessage;
  }
  return `${errorJSONMaybe}`;
};
export const logError = ({
  componentName,
  error,
  extra
}) => {
  Raven.captureException(error, {
    extra: {
      errorMessage: getErrorMessage(error.networkError || error),
      extra
    },
    tags: {
      componentName: componentName || 'Unknown component'
    }
  });
};
const handleError = (error, extra) => {
  // Log error
  logError(Object.assign({
    error
  }, extra && {
    extra
  }));
};
export default handleError;